/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Calm_Tiger_RoarInputs */

const en_swift_calm_tiger_roar = /** @type {(inputs: Swift_Calm_Tiger_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_swift_calm_tiger_roar = /** @type {(inputs: Swift_Calm_Tiger_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Swift_Calm_Tiger_RoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_calm_tiger_roar = /** @type {((inputs?: Swift_Calm_Tiger_RoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Calm_Tiger_RoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_calm_tiger_roar(inputs)
	return de_swift_calm_tiger_roar(inputs)
});